export const BANNER_RECOMMENDATION_LIST_SUCCESS = 'BANNER_RECOMMENDATION_LIST_SUCCESS';
export const CREATE_BANNER_RECOMMENDATION_SUCCESS = 'CREATE_BANNER_RECOMMENDATION_SUCCESS';
export const EDIT_BANNER_RECOMMENDATION_SUCCESS = 'EDIT_BANNER_RECOMMENDATION_SUCCESS';
export const DELETE_BANNER_RECOMMENDATION_SUCCESS = 'DELETE_BANNER_RECOMMENDATION_SUCCESS';
